import React           from 'react';
import colors          from '../../utils/colors'
import { makeStyles }  from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
    root: {
        height:         70,
        top:            105,
        width:          150,
        position:       'fixed',
        right:          27,
        display:        'flex',
        textAlign:      'right',
        justifyContent: 'flex-start',
        flexFlow:       'column',
        zIndex:         999,     //   border: '1px solid #F00'
    },
    levelText: {
        color:     colors.blue,
        fontSize:  28,
        textAlign: 'right',
        transform: 'translate(0px, -10px)'
    },
    button: {
        height:          40,
        width:           150,
        fontSize:        18,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        textAlign:       'center',
        borderRadius:    '0.5em',
        backgroundColor: colors.blue,
        color:           '#FFF',
        cursor:          'pointer'
    }
}))

type NextLevelButtonProps = {
    level:               number;
    handleGoToNextLevel: () => void;
}

const NextLevelButton: React.FC<NextLevelButtonProps> = ({ 
    level, 
    handleGoToNextLevel 
}) => {

  const classes = useStyles();
 

  return (
    <div className = { classes.root }>
        <div 
          dir       = { 'rtl' }
          className = { classes.levelText }
        >
            { `שלב ${ level }` }
        </div>
        {
            level === 1
            &&
            <div 
                className = { classes.button }
                onClick   = { handleGoToNextLevel }
                dir       = { 'rtl' }
            >
                { `לשלב הבא` }
            </div> 
        }
    </div>
  );
}



export default NextLevelButton;








